// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"84":"8ec69c14","254":"e7ddbb34","532":"581f3f8b","724":"319e0d78"}[chunkId] + ".js";
};